module.exports = __webpack_public_path__ + "static/media/province0.4743940a.png";